import { useState, useEffect } from 'react';

const useIsApple = () => {
  const [isApple, setIsApple] = useState(false);

  useEffect(() => {
    setIsApple(/iPad|iPhone|iPod/i.test(navigator.userAgent));
  }, []);

  return isApple;
};

export default useIsApple;
